import type { SVGProps } from 'react';

const SvgPreferredMessaging = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32" {...props}>
    <g fill={props.color} data-name="preffered-messaging">
      <path d="M.44 24a2.75 2.75 0 0 0 2.75 2.75h11.29l8.6 5a.7.7 0 0 0 .38.1.7.7 0 0 0 .37-.1.75.75 0 0 0 .38-.65v-4.32h4A2.75 2.75 0 0 0 31 24V2.84A2.75 2.75 0 0 0 28.22.09h-25A2.75 2.75 0 0 0 .44 2.84Zm1.5-21.16a1.25 1.25 0 0 1 1.25-1.25h25a1.25 1.25 0 0 1 1.25 1.25V24a1.25 1.25 0 0 1-1.25 1.25h-4.73a.75.75 0 0 0-.75.75v3.82l-7.65-4.47a.8.8 0 0 0-.38-.1H3.19A1.25 1.25 0 0 1 1.94 24Z" />
      <path d="m12.15 11.51-1.06 1.06 3.52 3.53a.74.74 0 0 0 .53.22.7.7 0 0 0 .53-.22L25.8 6l-1.06-1-9.6 9.56Z" />
      <path d="M15.21 22.19a8.67 8.67 0 0 0 8.66-8.67 9 9 0 0 0-.21-1.93l-1.46.34a7.7 7.7 0 0 1 .17 1.59 7.15 7.15 0 1 1-3.14-5.93l.84-1.24a8.67 8.67 0 1 0-4.86 15.84" />
    </g>
  </svg>
);

export default SvgPreferredMessaging;
